import api from '@/services/Api'

// ----------------------------- o

const namespaced = true;

// ----------------------------- o

const state = {
    errors: {},
    loading: false,
    category: null, // default category was set to 'all' but not anymore
    levels: [],
    lessons: [],
    single: {},
    test: [],
    exam: [],
    answers: null,
    summary: {}
};

// ----------------------------- o

const getters = {

};

// ----------------------------- o

const actions = {
    'KNOWLEDGE_TRAININGS_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_TRAININGS_REQUEST');
            let url = 'knowledges/trainings/levels?per_page=100';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('KNOWLEDGE_TRAININGS_SUCCESS', resp.data.data);
                    // select first possible category
                    dispatch('KNOWLEDGE_TRAININGS_SET_CATEGORY', resp.data.data ? resp.data.data[0].slug : null);
                    resolve(resp)
                })
                .catch(err => {
                    commit('KNOWLEDGE_TRAININGS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'KNOWLEDGE_TRAININGS_SINGLE_REQUEST': ({commit, dispatch}, lesson_slug) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_TRAININGS_REQUEST');
            let url = 'knowledges/trainings/lessons/'+lesson_slug;
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('KNOWLEDGE_TRAININGS_SET_SINGLE', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('KNOWLEDGE_TRAININGS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'KNOWLEDGE_TRAININGS_TEST_REQUEST': ({commit, dispatch}, lesson_slug) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_TRAININGS_REQUEST');
            let url = 'knowledges/trainings/lessons/' + lesson_slug + '/test';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('KNOWLEDGE_TRAININGS_SET_TEST', resp.data.data);
                    // this test possibly has been passed correctly - optional message
                    if(resp.data.message){
                        dispatch('GLOBAL_TOAST', resp.data.message, {root:true})
                    }
                    resolve(resp)
                })
                .catch(err => {
                    commit('KNOWLEDGE_TRAININGS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'KNOWLEDGE_TRAININGS_EXAM_REQUEST': ({commit, dispatch}, level_slug) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_TRAININGS_REQUEST');
            let url = 'knowledges/trainings/levels/' + level_slug + '/exam';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('KNOWLEDGE_TRAININGS_SET_EXAM', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('KNOWLEDGE_TRAININGS_CLEAR_EXAM');
                    commit('KNOWLEDGE_TRAININGS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'KNOWLEDGE_TRAININGS_TEST_STORE': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_TRAININGS_REQUEST');
            commit('KNOWLEDGE_TRAININGS_USER_ANSWERS', payload.data.test);
            let url = 'knowledges/trainings/lessons/' + payload.lesson_slug + '/test/store';
            api({url: url, data: payload.data, method: 'POST'})
                .then(resp => {
                    commit('KNOWLEDGE_TRAININGS_TEST_STORE_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('KNOWLEDGE_TRAININGS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'KNOWLEDGE_TRAININGS_EXAM_STORE': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_TRAININGS_REQUEST');
            commit('KNOWLEDGE_TRAININGS_USER_ANSWERS', payload.data.exam);
            let url = 'knowledges/trainings/levels/' + payload.level_slug + '/exam/store';
            api({url: url, data: payload.data, method: 'POST'})
                .then(resp => {
                    commit('KNOWLEDGE_TRAININGS_TEST_STORE_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('KNOWLEDGE_TRAININGS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'KNOWLEDGE_TRAININGS_SET_CATEGORY': ({commit, dispatch}, category) => {
        commit('KNOWLEDGE_TRAININGS_SET_CATEGORY', category);
    },
}

// ----------------------------- o

const mutations = {
    'KNOWLEDGE_TRAININGS_REQUEST': (state) => {
        state.errors = {};
        state.loading = true;
    },
    'KNOWLEDGE_TRAININGS_SUCCESS': (state, resp) => {
        state.levels = resp;
        state.loading = false;
    },
    'KNOWLEDGE_TRAININGS_ERROR': (state, resp) => {
        state.errors = resp;
        state.loading = false;
    },
    'KNOWLEDGE_TRAININGS_SET_CATEGORY': (state, category) => {
        state.category = category;
        if(state.category !== 'all'){
            let obj = state.levels.find(x => x.slug === state.category)
            return state.lessons = obj.lessons;
        }else{
            let lessons = [];
            state.levels.forEach((item, key) => {
                let arr = item.lessons;
                lessons = lessons.concat(arr)
            })
            return state.lessons = lessons;
        }
    },
    'KNOWLEDGE_TRAININGS_SET_SINGLE': (state, data) => {
        state.single = data;
        state.loading = false;
    },
    'KNOWLEDGE_TRAININGS_SET_TEST': (state, resp) => {
        state.test = resp;
        state.loading = false;
    },
    'KNOWLEDGE_TRAININGS_SET_EXAM': (state, resp) => {
        state.exam = resp;
        state.loading = false;
    },
    'KNOWLEDGE_TRAININGS_CLEAR_EXAM': (state) => {
        state.exam = [];
    },
    'KNOWLEDGE_TRAININGS_USER_ANSWERS': (state, payload) => {
        state.answers = payload;
        state.loading = false;
    },
    'KNOWLEDGE_TRAININGS_TEST_STORE_SUCCESS': (state, resp) => {
        state.summary = resp;
        state.loading = false;
    },
}

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}